/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：product_list_pc（361 个 D 位坑位，16 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_LIST_PC_SPM_CODES = {
  breadcrumb: {
    code: `${sitePrefix}.product_list_pc.breadcrumb`,
    'breadcrumb_item_{NN}': `${sitePrefix}.product_list_pc.breadcrumb.breadcrumb_item_{NN}`,
  },
  collection_banner: {
    code: `${sitePrefix}.product_list_pc.collection_banner`,
  },
  color_filter: {
    code: `${sitePrefix}.product_list_pc.color_filter`,
    'color_option_{NN}': `${sitePrefix}.product_list_pc.color_filter.color_option_{NN}`,
    toggle_color_filter: `${sitePrefix}.product_list_pc.color_filter.toggle_color_filter`,
  },
  gender_filter: {
    code: `${sitePrefix}.product_list_pc.gender_filter`,
    'gender_option_{NN}': `${sitePrefix}.product_list_pc.gender_filter.gender_option_{NN}`,
    toggle_gender_filter: `${sitePrefix}.product_list_pc.gender_filter.toggle_gender_filter`,
  },
  list_faq: {
    code: `${sitePrefix}.product_list_pc.list_faq`,
    'open_answer_link_{NN}': `${sitePrefix}.product_list_pc.list_faq.open_answer_link_{NN}`,
    'toggle_question_{NN}': `${sitePrefix}.product_list_pc.list_faq.toggle_question_{NN}`,
  },
  list_toolbar: {
    code: `${sitePrefix}.product_list_pc.list_toolbar`,
    clear_all: `${sitePrefix}.product_list_pc.list_toolbar.clear_all`,
    filter_apply: `${sitePrefix}.product_list_pc.list_toolbar.filter_apply`,
    open_sort: `${sitePrefix}.product_list_pc.list_toolbar.open_sort`,
  },
  material_filter: {
    code: `${sitePrefix}.product_list_pc.material_filter`,
    'material_option_{NN}': `${sitePrefix}.product_list_pc.material_filter.material_option_{NN}`,
    toggle_material_filter: `${sitePrefix}.product_list_pc.material_filter.toggle_material_filter`,
  },
  pagination: {
    code: `${sitePrefix}.product_list_pc.pagination`,
    next_page: `${sitePrefix}.product_list_pc.pagination.next_page`,
    'page_number_{NN}': `${sitePrefix}.product_list_pc.pagination.page_number_{NN}`,
    previous_page: `${sitePrefix}.product_list_pc.pagination.previous_page`,
  },
  prescription_filter: {
    code: `${sitePrefix}.product_list_pc.prescription_filter`,
    'prescription_option_{NN}': `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_{NN}`,
    toggle_prescription_filter: `${sitePrefix}.product_list_pc.prescription_filter.toggle_prescription_filter`,
  },
  price_filter: {
    code: `${sitePrefix}.product_list_pc.price_filter`,
    'price_option_{NN}': `${sitePrefix}.product_list_pc.price_filter.price_option_{NN}`,
    toggle_price_filter: `${sitePrefix}.product_list_pc.price_filter.toggle_price_filter`,
  },
  product_results: {
    code: `${sitePrefix}.product_list_pc.product_results`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.product_list_pc.product_results.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.product_list_pc.product_results.favorite_{NNN}`,
    'product_{NNN}': `${sitePrefix}.product_list_pc.product_results.product_{NNN}`,
    'try_on_{NNN}': `${sitePrefix}.product_list_pc.product_results.try_on_{NNN}`,
  },
  related_categories_bottom: {
    code: `${sitePrefix}.product_list_pc.related_categories_bottom`,
    'category_entry_{NN}': `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_{NN}`,
  },
  seo_content: {
    code: `${sitePrefix}.product_list_pc.seo_content`,
    next: `${sitePrefix}.product_list_pc.seo_content.next`,
    open_progressive_glasses: `${sitePrefix}.product_list_pc.seo_content.open_progressive_glasses`,
    open_rectangle_glasses: `${sitePrefix}.product_list_pc.seo_content.open_rectangle_glasses`,
    open_titanium_glasses: `${sitePrefix}.product_list_pc.seo_content.open_titanium_glasses`,
    previous: `${sitePrefix}.product_list_pc.seo_content.previous`,
    'select_article_{NN}': `${sitePrefix}.product_list_pc.seo_content.select_article_{NN}`,
  },
  shape_filter: {
    code: `${sitePrefix}.product_list_pc.shape_filter`,
    'shape_option_{NN}': `${sitePrefix}.product_list_pc.shape_filter.shape_option_{NN}`,
    toggle_shape_filter: `${sitePrefix}.product_list_pc.shape_filter.toggle_shape_filter`,
  },
  size_filter: {
    code: `${sitePrefix}.product_list_pc.size_filter`,
    'size_option_{NN}': `${sitePrefix}.product_list_pc.size_filter.size_option_{NN}`,
    toggle_size_filter: `${sitePrefix}.product_list_pc.size_filter.toggle_size_filter`,
  },
  sort_options: {
    code: `${sitePrefix}.product_list_pc.sort_options`,
    'sort_option_{NN}': `${sitePrefix}.product_list_pc.sort_options.sort_option_{NN}`,
  },
} as const satisfies SpmPageCodes;
